import { ChangeEvent } from 'react';
import { MonthProps } from './Month.interface';
import { Select } from 'components/select';
import { RenderIf } from 'components/render-if';
import { AssistiveText } from '@axa-fr-axion/inputs';

const MONTHS = [ 'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre' ];
const DEFAULT_START_AT = 0;
const DEFAULT_END_AT = 12;
const NUMBER_LIMIT = 2;

export const Month = ({
    onChange,
    data,
    defaultValue,
    className,
    label,
    placeholder,
    startAt = DEFAULT_START_AT,
    endAt = DEFAULT_END_AT,
    isDateValid,
}: MonthProps): JSX.Element => {
    const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value;
        const validity = value ? 'Valid' : 'Invalid';
        onChange?.(value, validity);
    };

    const options = MONTHS.slice(startAt, endAt).map(
        (month, index) => ({ label: month, value: `${ index + 1 }`.padStart(NUMBER_LIMIT, '0') }));

    return (
        <div>
            <Select
                className={ className }
                dataInput={ options }
                name='month'
                defaultValue={ defaultValue }
                placeholder={ placeholder }
                label={ label }
                value={ data }
                onChange={ handleChange }
            />
            <RenderIf value={ !!isDateValid }>
                <AssistiveText
                    level={ 'error' }
                    text={ 'La date de mise en circulation ne doit pas dépasser la date d’aujourd’hui.' }
                />
            </RenderIf>
        </div>
    );
};
